import apiService from "./apiService";
import AppConstants from "../appConstants";
import LocalStorageHelper from "../helpers/local-storage-helper";
import localStorageHelper from "../helpers/local-storage-helper";
import EventEmitter from "events";
import router from "../router";
import acceptorService from "./acceptorService";
import layoutService from "@/providers/layoutService";
import store from '../store/store';
import VueI18n from '../i18n/i18n';
import { getCodeLang } from '../helpers/locale-helper';
import pushwooshService from "@/providers/pushwooshService";
import checkDeviceTypeHelper from "@/helpers/check-device-type-helper";
import { stopCountAndSendSpentTime } from '../plugins/TimeSpend';

class AuthService extends EventEmitter {

  loginData = null;
  isLoggedIn = false;

  login(form, params) {
    return new Promise((resolve, reject) => {
      apiService.post(AppConstants.URL_LOGIN, form, params)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  getAccessTokenFromRefreshToken(form, params) {
    return new Promise((resolve, reject) => {
      apiService.post(AppConstants.URL_REFRESH_TOKEN, form, params)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  S4login(form, params) {
    return new Promise((resolve, reject) => {
      apiService.post(AppConstants.URL_S4LOGIN, form, params)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  // fakeLogin() {
  //   console.log('fake login');
  //   return new Promise((resolve, reject) => {
  //     resolve({
  //       token: "eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJhZG1pbkBjbWEuY29tLmJyIiwiYXV0IjpbeyJhdXRob3JpdHkiOiJST0xFX01FTlVfUFVCTElTSF9TRU5EIn1dLCJ1c2VyX2FnZW5jeSI6IltdIiwidXNlcl9jb2RlIjoyLCJ1c2VyX3RvcGljcyI6Ilt7XCJ0b3BfSW50VG9waWNcIjogMSwgXCJ0b3BfQ2hhVG9waWNcIjogXCJBR0VOQ0lBQ01BXCJ9LHtcInRvcF9JbnRUb3BpY1wiOiAyLCBcInRvcF9DaGFUb3BpY1wiOiBcIlNBRlJBU0NPTk5FQ1RcIn1dIiwidXNlcl9uYW1lIjoiQWRtaW4iLCJjcmVhdGVkIjoxNTcyMzY3NTg0ODI0LCJ1c2VyX3Byb2ZpbGUiOiJBRE1JTiIsImV4cCI6MTU3Mjk3MjM4NH0.uaZie-mnuJqBwYVRA6FRkL98tp9HUyACCjdrDq-7V4E-RCtJrCYXaK5n5kCLEfmfp1b8N8wCsvnRZ3oGOwY-Xw"
  //     });
  //   });
  // }

  successLogin(authResult, s4Login) {
    this.isLoggedIn = true;
    const auth = this.saveLayoutIfResponseEmpty(authResult);

    this.loginData = {
      nome: auth.nome,
      token: auth.token,
      refreshToken: auth.refreshToken,
      auth: auth.auth,
      email: auth.email,
      rights: auth.rights,
      metadata: auth.metadata,
      theme: auth.theme,
      viewstyle: auth.viewstyle,
      hasQuotesRights: auth.hasQuotesRights,
      favoriteContent: auth.favoriteContent,
      skipTour: auth.skipTour,
      afterLoginShowBiometry: auth.afterLoginShowBiometry,
      s4Login: s4Login,
      originCode: auth.originCode,
      rateTextSpeech: auth.rateTextSpeech,
      profile: auth.profile,
      signature: auth.signature,
    };

    // console.warn(this.loginData);

    LocalStorageHelper.saveData(AppConstants.LOCAL_STORAGE_HAS_LOGGED_IN, true);
    LocalStorageHelper.setCurrentUser(this.loginData);

    if (auth.language) {
      LocalStorageHelper.saveData(AppConstants.LOCAL_STORAGE_LOCALE, auth.language);
      VueI18n.locale = getCodeLang(auth.language);
    }

    if (auth.theme) {
      localStorageHelper.saveData(AppConstants.LOCAL_STORAGE_THEME, auth.theme);
      store.dispatch("updateTheme", auth.theme);
    }
    if (auth.viewstyle) {
      localStorageHelper.saveData(AppConstants.LOCAL_STORAGE_REPORT_VIEW_STYLE, auth.viewstyle);
      store.dispatch("reportListStyle", auth.viewstyle);
    }
    if (auth.zoom) {
      localStorageHelper.updateZoom(auth.zoom);
    }
    if (auth.zoomDetail) {
      localStorageHelper.updateZoomDetail(auth.zoomDetail);
    }
    if (auth.formatAlignDetail) {
      localStorageHelper.updateFormatAlignDetail(auth.formatAlignDetail);
    }

    localStorageHelper.updateUserSkipTour(auth.skipTour);

    store.dispatch('updateUserAuthenticated', true);

    // Listener of this event login has been in auth.js
    this.emit(AppConstants.EVENT_LOGIN, {
      loggedIn: true,
      loginData: this.loginData
    });

    return this.loginData;
  }

  saveLayoutIfResponseEmpty(authResult) {
    const form = {};
    const theme = window.localStorage.getItem(AppConstants.LOCAL_STORAGE_THEME);
    const viewstyle = window.localStorage.getItem(AppConstants.LOCAL_STORAGE_REPORT_VIEW_STYLE);

    if (!authResult.theme && theme) {
      form.theme = theme;
      authResult.theme = theme;
    }

    if (!authResult.viewstyle && viewstyle) {
      form.viewstyle = viewstyle;
      authResult.viewstyle = viewstyle;
    }

    // TODO SAVE LAYOUT
    // if (form.theme || form.viewstyle) {
    //   layoutService.saveLayout(form, new URLSearchParams()).then(() => console.log('layout saved'));
    // }

    return authResult;
  }

  updateUserRights(rights, hasQuotesRights, refresh = false) {
    const user = LocalStorageHelper.getCurrentUser();
    user.rights = rights;
    user.hasQuotesRights = hasQuotesRights;
    LocalStorageHelper.setCurrentUser(user);

    if (refresh) {
      window.location.reload();
    }
  }

  async logout() {
    console.log('[logout system]');
    const redirectToLogin = !checkDeviceTypeHelper.isNativeApp();
    try {
      await stopCountAndSendSpentTime(false);
    } catch (error) { console.log('[stopCountAndSendSpentTime][error] ', error) }
    try {
      const { acptoken, refresh_token, email, token } = localStorageHelper.getCurrentUser();
      const bodyLogout = {
        email: email,
        token: token,
        acceptor_token: acptoken,
        refresh_token: refresh_token,
      };

      const deviceId = localStorage.deviceId;
      if (deviceId && deviceId !== 'undefined') {
        bodyLogout['device_id'] = deviceId;
      }
      
      await this.logoutSystem(bodyLogout, new URLSearchParams());
      this.clearCache(redirectToLogin);
    } catch (error) {
      console.log('[logout] Error: ', error);
      this.clearCache(redirectToLogin);
      // this.clearCache(redirectToLogin);
    }
    
    // this.logoutPush();
    
    this.isLoggedIn = false;
    this.loginData = null;
    if (localStorageHelper.getS4Login()) {
      // this.$router.push({query: {q: this.searchQuery}});
      router.push({ path: AppConstants.NAVIGATION_PAGE_S4LOGIN, query: { error: AppConstants.ERROR_S4_TOKEN } });
    } else {
      // router.push({ path: AppConstants.NAVIGATION_PAGE_LOGIN });
      store.commit('UPDATE_DISPLAY_SYSTEM', false);
    }
    
  }

  clearCache(redirectToLogin = false) {
    this.emit(AppConstants.EVENT_LOGIN, { loggedIn: false });
    // if (!noRedirect) {
    //   router.push({ path: AppConstants.NAVIGATION_PAGE_LOGIN });
    // }
    store.dispatch('updateUserAuthenticated', false);
    // localStorageHelper.clear();
    LocalStorageHelper.removeItem(AppConstants.LOCAL_STORAGE_HAS_LOGGED_IN);
    LocalStorageHelper.removeItem(AppConstants.LOCAL_STORAGE_CURRENT_USER);
    LocalStorageHelper.removeItem(AppConstants.LOCAL_STORAGE_USER_SKIP_TOUR);
    LocalStorageHelper.removeItem(AppConstants.LOCAL_STORAGE_FAVORITE_CONTENT);
    // LocalStorageHelper.removeItem(AppConstants.LOCAL_STORAGE_LOCALE);
    // LocalStorageHelper.removeItem(AppConstants.LOCAL_STORAGE_THEME);
    LocalStorageHelper.removeItem(AppConstants.LOCAL_STORAGE_REPORT_VIEW_STYLE);
    LocalStorageHelper.removeItem(AppConstants.LOCAL_STORAGE_EVENT_ON_LOGIN);
    if (redirectToLogin) {
      router.push({ path: checkDeviceTypeHelper.getUrlLogin() });
    }
    setTimeout(() => {
      // router.push({ path: AppConstants.NAVIGATION_PAGE_HOME });
      console.log('clearing cache after logout');
      document.location.reload();
    }, 400);
  }

  async logoutAcceptor() {
    console.log('[logout system] acceptor');
    const { acptoken, refresh_token, email } = localStorageHelper.getCurrentUser();
    if (acptoken || refresh_token) {
      try {
        await acceptorService.logout({ token: acptoken, refresh_token: refresh_token, email: email }, new URLSearchParams());
        localStorageHelper.clearAcceptorToken();
      } catch (error) {
        localStorageHelper.clearAcceptorToken();
      }
    }
  }

  logoutPush() {
    const deviceId = localStorage.deviceId;
    if (deviceId && deviceId !== 'undefined') {
      pushwooshService.removeClientDeviceId(deviceId, new URLSearchParams())
        .then(response => {
          console.log(`removed device id ${deviceId} with success`);
        })
        .catch(error => {
          console.log(`error removing device id ${deviceId}`);
        });
    }
  }

  isAuthenticated() {
    return LocalStorageHelper.getUserHasLoggedIn() === 'true';
  }

  getMainMenu(params) {
    return new Promise((resolve, reject) => {
      apiService.get(AppConstants.URL_GET_MAIN_MENU, params)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  async logoutSystem(form, params) {
    return new Promise((resolve, reject) => {
      apiService.post(AppConstants.URL_LOGOUT, form, params)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  register(form, params) {
    return new Promise((resolve, reject) => {
      apiService.post(AppConstants.URL_REGISTER, form, params)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  validateTwoFactorAuthToken(form, params) {
    return new Promise((resolve, reject) => {
      apiService.post(AppConstants.URL_VALIDATE_TWO_FACTOR_AUTH_EMAIL, form, params)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  validateConfirmEmailToken(form, params) {
    return new Promise((resolve, reject) => {
      apiService.post(AppConstants.URL_VALIDATE_CONFIRM_EMAIL_TOKEN, form, params)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  sendConfirmEmailToken(email, params) {
    return new Promise((resolve, reject) => {
      apiService.get(`${AppConstants.URL_SEND_CONFIRM_EMAIL_TOKEN}/${email}`, params)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
  resendTokenTwoFactorAuth(email, params) {
    return new Promise((resolve, reject) => {
      apiService.get(`${AppConstants.URL_RESEND_TWO_FACTOR_AUTH_EMAIL}/${email}`, params)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  getConfig(url, auth) {
    return new Promise((resolve, reject) => {
      apiService.getWithBasicAuth(url, auth)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  }
}
export default new AuthService();
